export const BRAND = '#15A08C';
export const BRAND_DARK = '#0F6E56';
export const BRAND_SOFT = '#E1F5EE';
export const BRAND_INK = '#04342C';
export const INK = '#0E1A1A';
export const BLACK = '#000000';
export const TEXT_INK = '#1A2332';
export const BG_CARD = '#FFFFFF';
export const BG_PAGE = '#F8F9FA';
export const BORDER = '#E5E7EB';
export const DANGER = '#A32D2D';
export const DANGER_SOFT = '#FCEBEB';
export const DANGER_INK = '#791F1F';
export const DANGER_PILL_BG = '#FBEAF0';
export const DANGER_PILL_INK = '#4B1528';
export const DANGER_PILL_TEXT = '#993556';
export const WARN_BG = '#FAEEDA';
export const WARN_BORDER = '#F0D89A';
export const WARN_TEXT = '#854F0B';
export const PAUSED_BG = '#F1EFE8';
export const PAUSED_INK = '#444441';